
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[id]/following",
      function () {
        return require("private-next-pages/user/[id]/following.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[id]/following"])
      });
    }
  